<app-back-button></app-back-button>
<div class="contents">
  <!-- ════ PAGE HEADER ════ -->
  <div class="page-header">
    <div>
      <h1 class="page-header-title">Gestão de Campanhas</h1>
      <p class="page-header-sub">Veja, valide e gerencie todas as campanhas da plataforma</p>
    </div>

    <div class="page-header-actions">
      <div class="header-stat-pill">
        <i class="fas fa-bullhorn text-primary"></i>
        <span>Total: <strong>{{ totalCampanhas }}</strong></span>
      </div>

      <button
        type="button"
        class="btn btn-outline btn-sm"
        (click)="showDestaques()"
      >
        <i class="fas fa-star" [style.color]="showDestacados ? '#f59e0b' : 'inherit'"></i>
        <span>{{ labelButton }}</span>
      </button>
    </div>
  </div>

  <!-- Estatísticas de Campanhas por Estado (Clicáveis para filtrar) -->
  <div class="campanhas-stats-container mb-4" *ngIf="!loadingStats && campanhasPorEstado.length > 0">
    <div
      class="campanha-stat-chip all-chip"
      [class.active]="selectedEstadoENUM === null && !showDestacados"
      (click)="selectEstado(null)"
    >
      <span class="stat-dot"></span>
      <span class="stat-name">Todas</span>
      <span class="stat-count">{{ totalCampanhas }}</span>
    </div>

    <!-- Filtro de Campanhas em Destaque -->
    <div
      class="campanha-stat-chip chip-destaque"
      [class.active]="showDestacados"
      (click)="selectDestaques()"
      title="Filtrar campanhas em destaque"
    >
      <span class="stat-dot-star"><i class="fas fa-star"></i></span>
      <span class="stat-name">Em Destaque</span>
      <span class="stat-count">{{ totalDestaques }}</span>
    </div>

    <div
      class="campanha-stat-chip"
      *ngFor="let item of campanhasPorEstado"
      [ngClass]="getBadgeClass(item.estadoCampanha)"
      [class.active]="!showDestacados && selectedEstadoENUM === item.estadoCampanhaENUM"
      (click)="selectEstado(item.estadoCampanhaENUM)"
    >
      <span class="stat-dot"></span>
      <span class="stat-name">{{ item.estadoCampanha }}</span>
      <span class="stat-count">{{ item.total }}</span>
    </div>
  </div>

  <div *ngIf="!showDestacados">
    <app-admin-lista-campanhas [estadoCampanhaFilter]="selectedEstadoENUM" (destaqueFilterSelected)="selectDestaques()"></app-admin-lista-campanhas>
  </div>
  <div *ngIf="showDestacados">
    <app-lista-campanhas-destaques></app-lista-campanhas-destaques>
  </div>
</div>
